import React from 'react';

// "Keep growing" (weekly refresh, migration 223): a person the refresh added
// carries custom_data.refresh_added_at. They're tagged "New" for 30 days,
// then the tag simply stops showing — nothing to clean up.
const NEW_DAYS = 30;

const addedAtOf = (row: any): Date | null => {
  let cd = row && row.custom_data;
  if (typeof cd === 'string') { try { cd = JSON.parse(cd); } catch { cd = null; } }
  const at = cd && cd.refresh_added_at ? new Date(cd.refresh_added_at) : null;
  return at && !isNaN(at.getTime()) ? at : null;
};

export const isNewFromRefresh = (row: any) => {
  const at = addedAtOf(row);
  return !!at && Date.now() - at.getTime() < NEW_DAYS * 86400000;
};

export const NewFromRefreshBadge: React.FC<{ row: any }> = ({ row }) => {
  const at = addedAtOf(row);
  if (!at || Date.now() - at.getTime() >= NEW_DAYS * 86400000) return null;
  const day = at.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  // Started their current role recently: most likely a fresh hire.
  const start = row.current_position_start_date ? new Date(row.current_position_start_date) : null;
  const weeks = start && !isNaN(start.getTime()) ? Math.floor((Date.now() - start.getTime()) / (7 * 86400000)) : null;
  const hire = weeks !== null && weeks >= 0 && weeks <= 13
    ? ` — started${row.current_company ? ` at ${row.current_company}` : ''} ${weeks <= 1 ? 'in the last week or two' : `${weeks} weeks ago`}`
    : '';
  return (
    <span
      className="inline-flex items-center ml-1.5 px-1.5 py-0.5 text-[10px] font-semibold rounded border align-middle whitespace-nowrap bg-emerald-50 text-emerald-800 border-emerald-200"
      title={`Added by this project's weekly refresh on ${day}${hire}. The tag goes after ${NEW_DAYS} days.`}
    >
      New{hire ? ' · recent hire' : ''}
    </span>
  );
};
